import React, { useState } from 'react';
import { apiFetch } from './api';
import './Auth.css';

const ProfileDialog = ({ user, onUpdated, onManageUsers, onClose }) => {
  const [risk, setRisk] = useState(String(user.riskPerTrade ?? 200));
  const [trainingRisk, setTrainingRisk] = useState(String(user.trainingRiskPerTrade ?? user.riskPerTrade ?? 200));
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const save = async (event) => {
    event.preventDefault();
    setBusy(true);
    setMessage('');
    setError('');
    try {
      const response = await apiFetch('/api/profile', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ riskPerTrade: risk, trainingRiskPerTrade: trainingRisk }),
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error || 'Unable to update profile');
      onUpdated(body.user);
      setRisk(String(body.user.riskPerTrade));
      setTrainingRisk(String(body.user.trainingRiskPerTrade));
      setMessage('Risk per trade saved');
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  };

  return <div className="admin-backdrop" role="presentation" onMouseDown={(event) => {
    if (event.target === event.currentTarget) onClose();
  }}>
    <section className="admin-dialog profile-dialog" role="dialog" aria-modal="true" aria-label="Profile">
      <header>
        <div><strong>Profile</strong><span>{user.username}</span></div>
        <button type="button" onClick={onClose} aria-label="Close profile">×</button>
      </header>
      <form onSubmit={save}>
        <h2>Trading</h2>
        <label className="profile-risk-field">
          <span>Live risk per trade ($)</span>
          <input type="number" min="0.01" step="0.01" value={risk} onChange={(event) => setRisk(event.target.value)} />
        </label>
        <label className="profile-risk-field">
          <span>Training risk per trade ($)</span>
          <input type="number" min="0.01" step="0.01" value={trainingRisk} onChange={(event) => setTrainingRisk(event.target.value)} />
        </label>
        <button type="submit" disabled={busy || !(Number(risk) > 0) || !(Number(trainingRisk) > 0)}>{busy ? 'Saving…' : 'Save'}</button>
      </form>
      <p className="password-rule">Quantity = risk per trade ÷ (entry price − stop loss), rounded down. You can override quantity before buying.</p>
      {user.isAdmin && <button type="button" className="profile-users-button" onClick={onManageUsers}>Manage users</button>}
      {message && <div className="auth-message">{message}</div>}
      {error && <div className="auth-error">{error}</div>}
    </section>
  </div>;
};

export default ProfileDialog;
